import styled from "styled-components";

export const VerticalRadioGroup =  styled.div`

    display: flex;
    flex-direction: column;
    text-transform: capitalize;
    min-height: 100px;
    justify-content: space-evenly;
`;